import {Text} from 'src/design/atoms/Text';
import {Button} from 'src/design/atoms/Button';
import {useAppDispatch, useAppSelector} from 'src/redux/hooks';
import {confirmSignInUser} from 'src/redux/slices/authSlice';

export const SelectTotp = () => {
  const dispatch = useAppDispatch();
  const {signInNextStep, isLoading} = useAppSelector(state => state.auth);
  if (
    (signInNextStep?.signInStep !== 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION' &&
      signInNextStep?.signInStep !==
        'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION') ||
    !signInNextStep.allowedMFATypes?.includes('TOTP')
  ) {
    return <Text>Authenticator sign-in is unavailable. Contact support.</Text>;
  }
  return (
    <Button
      loading={isLoading}
      onClick={() => {
        void dispatch(confirmSignInUser({challengeResponse: 'TOTP'}));
      }}>
      Use authenticator app
    </Button>
  );
};
